import React, { useState, useEffect, useRef } from 'react';

function Chat({ messages, onSendMessage, isOpen, onToggle }) {
  const [message, setMessage] = useState('');
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim()) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={`chat-container ${isOpen ? 'open' : 'closed'}`}>
      <div className="chat-header">
        <h3>💬 Chat</h3>
        <button onClick={onToggle} className="chat-toggle-btn">
          {isOpen ? '→' : '←'}
        </button>
      </div>
      
      {isOpen && (
        <>
          <div className="chat-messages">
            {messages.length === 0 ? (
              <div className="chat-empty">No messages yet. Say hi! 👋</div>
            ) : (
              messages.map((msg, index) => (
                <div key={index} className="chat-message">
                  <span className="chat-user" style={{ color: msg.color }}>
                    {msg.userName}
                  </span>
                  <span className="chat-time">{formatTime(msg.timestamp)}</span>
                  <div className="chat-text">{msg.message}</div>
                </div>
              ))
            )}
            <div ref={messagesEndRef} />
          </div>
          
          <form onSubmit={handleSubmit} className="chat-input-form">
            <input
              type="text"
              placeholder="Type a message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              maxLength={200}
              className="chat-input"
            />
            <button type="submit" disabled={!message.trim()} className="chat-send-btn">
              Send
            </button>
          </form>
        </>
      )}
    </div>
  );
}

export default Chat;